import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { Loading } from '@makyoapp/makyo-ui'

import { lazyload } from '@/lib/lazy-load'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useAppContext } from '@/context/AppContext'

import { ProjectAction } from './ProjectToolbar'

const ProjectLayout = lazyload(() => import('./layout/ProjectLayout'))
const OrgDatabaseGrid = lazyload(() =>
  import('@/pages/org/databases/OrgDatabaseGrid').then((m) => ({ default: m.OrgDatabaseGrid }))
)

/**
 * @todo:
 *  - inject user dropdown toolbar
 */
const ProjectV2Routes = () => {
  const { project, updateVersion, isLoading: isLoadingBuilder } = useAppBuilderContext()
  const { setProjectAction } = useAppContext()
  const { loadingDbClient } = useDbClientContext()

  useEffect(() => {
    if (!project) return
    setProjectAction(<ProjectAction project={project} onPublished={updateVersion} />)
    return () => {
      setProjectAction(null)
    }
  }, [updateVersion, project, setProjectAction])

  if (loadingDbClient || isLoadingBuilder) {
    return <Loading />
  }

  return (
    <Routes>
      <Route path='/' element={<Navigate to='app' replace />} />
      <Route path='app/*' element={<ProjectLayout />} />
      <Route path='db/*' element={<OrgDatabaseGrid />} />
    </Routes>
  )
}

export default ProjectV2Routes
